import VimeoPlayer from "@vimeo/player";
import { prefersReducedMotion } from "../../Shared/Utilities/userPreferences";

const hero = document.querySelector<HTMLElement>("#home-page-hero");

if (hero) {
  const videoIframe = hero.querySelector<HTMLIFrameElement>("#home-page-hero-video");

  if (videoIframe?.dataset.src && !prefersReducedMotion()) {
    videoIframe.src = videoIframe.dataset.src;

    const videoPlayer = new VimeoPlayer(videoIframe);

    videoPlayer.on("play", () => {
      videoIframe.ariaHidden = "false";
    });

    const playPauseButton = hero.querySelector<HTMLElement>(
      "[data-js-play-pause-button]"
    );

    if (playPauseButton) {
      playPauseButton.addEventListener("click", () => {
        const playIcon = playPauseButton.querySelector<HTMLElement>(
          "[data-js-symbol-name='play']"
        );
        const pauseIcon = playPauseButton.querySelector<HTMLElement>(
          "[data-js-symbol-name='pause']"
        );

        if (playIcon && pauseIcon) {
          playIcon.classList.toggle("hidden");
          pauseIcon.classList.toggle("hidden");

          videoPlayer.getPaused().then(paused => {
            if (paused) {
              videoPlayer.play();
            } else {
              videoPlayer.pause();
            }
          });
        }
      });
    }
  }
}
